import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import Signals from 'signals';
import FilterModel from '../../../components/filter/data/filter.model';
import PanelOptionsService from '../panel-options.service';
import dvFilterService from '../../../components/dataset/services/dv-filter.service';
import '../../../components/filter/filter';

const nonSelectedText = '(select data source)';

function KpiAndTrendOptionsDialogVM(config) {
    var self = this;
    self.initialize(config);
}

KpiAndTrendOptionsDialogVM.prototype = {

    //  bound to UI functions

    apply: function () {
        var self = this;

        // set timeout to let any form inputs complete editing before closing
        setTimeout(()=> {
            self.modal.close({
                panel: PanelOptionsService.getPanelOptions(null, true), // 'true' means 'this is a top-list-panel' aka a dataset panel
                params: {
                    title: ko.unwrap(self.titleConfig.selectedOption),
                    datasetName: ko.unwrap(self.dataSourcesConfig.selectedOption),
                    visibleColumns: ko.unwrap(self.columnsConfig.selectedOption),
                    filters: self.filterModel.getActiveFilters()
                }
            });
        });
    },

    close: function () {
        var self = this;
        self.modal.close();
    },

    //  internally used-only base functions
    dispose: function () {
        var self = this;
        _.forEach(self.subscriptions, function (subscription) {
            subscription.dispose();
        });
    },

    getDataSourceByDatasetId: function (datasetName) {
        var self = this;
        var name = _.toLower(datasetName);
        return _.find(self.metadata, function (datasetMetadata) {
            return _.toLower(datasetMetadata.id) === name;
        });
    },

    initialize: function (config) {
        var self = this;
        self.subscriptions = [];
        self.doneEnabled = ko.observable(false);
        self.metadata = _.get(config, 'metadata', {});
        self.selectedOptions = _.get(config, 'selections', {});

        self.filterModel = new FilterModel();
        self.filterReadySignal = new Signals.Signal();
        self.filterDatasetName = ko.observable();

        self.setupPanelModelOptions();
        self.mustBeCalledAfterKoDecendentsComplete = self.setupConfigSelectors.bind(self);
    },

    setupConfigSelectors: function (p) {
        var self = this;
        var dataSource = self.getDataSourceByDatasetId(self.selectedOptions.datasetName);
        if (!_.isNil(dataSource)) {
            self.dataSourcesConfig.selectedOption(dataSource.id);
        }

        var visibleColumns = ko.unwrap(self.selectedOptions.visibleColumns);
        if (!_.isNil(visibleColumns)) {
            self.columnsConfig.selectedOption(visibleColumns);
        }

        var filters = self.selectedOptions.filters;
        if (!_.isNil(filters)) {
            if (_.isArray(filters)) { // convert from new to old model if needed
                filters = self.filterModel.convertOldFilters(filters);
            }
            self.filtersConfig.selectedOption(filters);
            self.filterModel.setActiveFilters(filters);
        }

        var title = self.selectedOptions.title;
        if (!_.isNil(title)) {
            self.titleConfig.selectedOption(title);
        }
    },

    //  internally used-only logic-related functions
    setupPanelModelOptions: function () {
        var self = this;

        self.titleConfig = {
            id: 'title',
            label: 'Panel Title:',
            selectedOption: ko.observable('Dataset')
        };

        self.dataSourcesConfig = {
            id: 'dataSources',
            label: 'Data Source:',
            availableOptions: ko.observableArray(getDataSourceOptions(self.metadata)),
            selectedOption: ko.observable({}),
            nonSelectedText: nonSelectedText,
            onUpdate: function () {
                var selectedValue = ko.unwrap(self.dataSourcesConfig.selectedOption);
                if (!selectedValue || selectedValue === nonSelectedText) {
                  self.doneEnabled(false);
                  return;
                }
                self.filterDatasetName(selectedValue);
                var datasetMetadata = _.find(self.metadata, function (item) {
                    //  this is double instead of triple equal comparison
                    //   since it can compare numbers vs string represented numbers
                    //   or strings vs strings
                    return item.id == selectedValue;
                });

                self.availableColumns = _.filter(datasetMetadata.columns, col => !col.invisible);

                self.columnsConfig.availableOptions(null);
                self.filtersConfig.availableOptions(null);
                self.columnsConfig.selectedOption(null);
                self.filtersConfig.selectedOption(null);
                self.filterModel.setActiveFilters({ filterGroups: [{ filters:[], operator: 'and' }], operator: 'and' });
                var columnOptions = getColumnOptions(self.availableColumns);
                self.columnsConfig.availableOptions(columnOptions);
                self.columnsConfig.selectedOption(_.map(_.slice(columnOptions,0,4),'value')); //default to first 4 columns

                var filters = dvFilterService.getFilterOptions(self.availableColumns);
                self.filterModel.setAvailableFilters(filters.availableFilters);

                if (datasetMetadata) {
                    self.titleConfig.selectedOption(datasetMetadata.name);
                }

                self.doneEnabled(true);
            }
        };

        self.columnsConfig = {
            id: 'visibleColumns',
            label: 'Table Columns:',
            availableOptions: ko.observableArray(null),
            selectedOption: ko.observableArray([]),
            selectConfig: {
                includeSelectAllOption: true,
                nonSelectedText: '(all)',
                numberDisplayed: 0,
                onChange: _.noop
            }
        };

        self.filtersConfig = {
            id: 'filters',
            label: 'Filters:',
            availableOptions: ko.observable({}),
            filterModel: self.filterModel,
            filterReadySignal: self.filterReadySignal,
            selectedOption: ko.observable()
        };

        self.subscriptions.push(
            self.dataSourcesConfig.selectedOption.subscribe(self.dataSourcesConfig.onUpdate)
        );

    }
};

function getColumnOptions(options) {
    return _.map(options, function (option) {
        return {
            text: _.get(option, 'name', option),
            value: _.get(option, 'id', option)
        };
    });
}

function getDataSourceOptions(options) {
    return _
        .chain(options)
        .filter(function(o) { return !o.excluded; })
        .sortBy('name')
        .map(function (option) {
            return {
                text: _.get(option, 'name', option),
                value: _.get(option, 'id', option)
            };
        })
        .value();
}

export default KpiAndTrendOptionsDialogVM;
